import React, { useState, useEffect } from "react";
import { injectModels } from "../../redux/injectModels";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  AuthService,
  EventService,
  GlobalSettingService,
  RatingReviewService,
} from "../../services";
import { Button, Form, Modal } from "react-bootstrap";
import { routes } from "../../constants/routes";

import {
  addUserDefaultImg,
  addUserDefaultImg2,
  addDefaultImg,
  formatDateENGB,
  formatAmount,
  handleConsoleError,
} from "../../utils/common-methods";

import { useDispatch } from "react-redux";
import * as CONSTANTS from "../../redux/Models/Application/constants";
import { toast } from "react-toastify";
import { UserRoleType } from "../../constants/Enum";
import ImagePreview from "../../components/Image/ImagePreview";
import { TraderUnitService } from "../../services";
import { GlobalConstant } from "../../constants";

const TraderProfile = (props) => {
  const { id, appId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let loginUser = AuthService.getLoginUser();
  const [showModal, setShow] = useState(false);
  const [showUnitDocumentModal, setUnitDocumentShow] = useState(false);
  const [showUnitShopModal, setUnitShopShow] = useState(false);
  const [rating, setRating] = useState(null);
  const [hover, setHover] = useState(null);
  const [totalStars] = useState(5);
  const [businessProfile, setBusinessProfile] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState("");
  const [comment, setComment] = useState("");
  const [imageList, setImageList] = useState([]);
  const [units, setUnits] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [unitShopFronts, setUnitShopFronts] = useState([]);
  const [isApplicationApproved, setIsApplicationApproved] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [eventName, setEventName] = useState("");
  const [isPreEventMessaging, setPreEventMessaging] = useState(false);

  useEffect(() => {
    const fetchEventData = async () => {
      await Promise.all([ props.application.getSwallowEO(),fetchGlobalValues(), getData()]);
    };
    fetchEventData();
  }, []);

  const fetchGlobalValues = async () => {
    try {
      const res = await GlobalSettingService.getGlobalSettingList();
      if (res?.isSuccess && res?.data?.length > 0) {
        const preEventMessaging = res?.data?.find(
          (item) =>
            item.keyName.trim() === GlobalConstant.PRE_EVENT_MESSAGING.trim()
        );
        if (preEventMessaging && preEventMessaging.isActive === true) {
          setPreEventMessaging(true);
        }
      }
    } catch (error) {
    const message= handleConsoleError(error);
     toast.error(error?.message|| message);
    }
  };
  const isGuid = (value) => {
  if (!value) return false;

  value = value.trim(); 

  const guidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  return guidRegex.test(value);
};


  const getData = async () => {
    try {
      let type = "R";
      if (appId) {
        let updatedAppId = appId;
        if (appId.includes("trader-profile-organizer-caterer")) {
          type = "C";
          updatedAppId = appId.replace("trader-profile-organizer-caterer", "");
        } else {
          updatedAppId = appId.replace("trader-profile-organizer-retailer", "");
        }
        try {
          if(isGuid(updatedAppId))
          {
          var res = await EventService.getEventApplicationStatusByType(
            updatedAppId,
            id,
            type
          );
          if (res?.isSuccess) {
            setIsApplicationApproved(res?.data?.isApproved);
            setEventId(res?.data?.eventId);
            setEventName(res?.data?.eventName);
          }
         
        }       
        } catch (error) {
        const message= handleConsoleError(error);
         toast.error(error?.message|| message);
        }
      }
      if (id && id.length > 5) {
        props.application.setLoading(true);
        const res = await RatingReviewService.getBusinessProfileById(id);
        if (res?.isSuccess && res?.data) {
          setBusinessProfile(res?.data);
          setImageList(res?.data?.images);
          await getFeedbacks(res?.data?.id);
          await getUnits(id);
        }
        props.application.setLoading(false);
      } else {
        navigate(routes.ERROR);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const getUnits = async (userId) => {
    try {
      var res = await TraderUnitService.getActiveUnitListByTraderId(userId);
      if (res?.isSuccess) {
        setUnits(res?.data || []);
      }
      // else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const handlePreview = (document) => {
    window.open(document, "_blank"); // Open PDF in new tab
  };
  const getUnitDocuments = async (unitId) => {
    try {
      const res = await TraderUnitService.getActiveDocumentsByUnitId(unitId);
      if (res?.isSuccess) {
        setDocumentsList(res?.data || []);
        setUnitDocumentShow(true);
      }
      // else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const getUnitShopFront = async (unitId) => {
    try {
      const res = await TraderUnitService.getActiveShopFrontsByUnitId(unitId);
      if (res?.isSuccess) {
        setUnitShopFronts(res?.data || []);
        setUnitShopShow(true);
      }
      // else{
      //   toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      // }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getFeedbacks = async (businessId) => {
    try {
      const res = await RatingReviewService.getBusinessReviewsById(businessId);
      if (res?.isSuccess && res?.data) {
        setReviews(res?.data ?? []);
      }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleSubmit = async () => {
    if (rating == null) {
      setError("Please add some rating.");
      return;
    }
    try {
      setError("");
      const data = {
        toUserId: businessProfile?.id,
        message: comment,
        rating: rating,
        eventId: eventId,
      };
      const res = await RatingReviewService.submitReview(data);
      if (res?.isSuccess && res?.data) {
        toast.success(res?.message);
        await getData();
        await getFeedbacks(businessProfile?.id);
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
    setShow(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleUnitShopClose = () => {
    // setUnitShopFronts([]);
    setUnitShopShow(false);
  };
  const handleUnitDocumentClose = () => {
    // setDocumentsList([]);
    setUnitDocumentShow(false);
  };
  const formatNull = (add) => {
    return add ? add + "," : "";
  };
  const formatNullWithOutComma = (add) => {
    return add ? add : "";
  };

  const showUnits = () => {
    //!businessProfile?.isOrganizer &&
    if (appId?.includes("trader-profile")) {
      return true;
    }
    if (appId?.includes("trader-profile-organizer")) {
      return true;
    }
    return false;
  };

  const getObscuredTextLabel = (text) => {
    return !showUnits() || isApplicationApproved || appId === "trader-profile"
      ? text
      : "*************";
  };

  const getObscuredText = () => {
    // return isApplicationApproved || eventUrl === "trader-profile"
    //   ? text
    //   : "*************";
    return isApplicationApproved || appId === "trader-profile"
      ? {}
      : { filter: "blur(8px)" };
  };

  const getObscuredSection = () => {
    return isApplicationApproved || appId === "trader-profile" ? true : false;
  };

  const getObscuredImages = () => {
    // style={{ marginBottom: "0px;" }}
    return isApplicationApproved || appId === "trader-profile"
      ? { marginBottom: "0px" }
      : { marginBottom: "0px" };

    // : { marginBottom: "0px;", filter: "blur(8px)" };
  };

  const isSuperUser =
    isPreEventMessaging &&
    loginUser?.id?.toLowerCase() ===
      props.application.swallowEO?.toLowerCase();

  const canMessageBusiness =
    getObscuredSection() &&
    loginUser &&
    loginUser?.role !== businessProfile?.userType &&
    loginUser?.role !== UserRoleType.UNKNOWN &&
    loginUser?.role !== UserRoleType.CUSTOMER;

  const shouldShowMessageButton = isSuperUser || canMessageBusiness;

  return (
    <React.Fragment>
      <section className="subscription-banner">
        <div className="container">
          <h3>Business Profile</h3>
        </div>
      </section>

      <section className="review-points">
        <div className="container poitns3">
          <div className="review-points1">
            <div className="review-points2">
              <img
                src={
                  businessProfile?.businessLogoUrl?.length > 0
                    ? businessProfile?.businessLogoUrl
                    : "/assets/images/users/user-dummy-img.jpg"
                }
                onError={addUserDefaultImg2}
                alt=""
              />
            </div>
            <div className="review-points3">
              <h3 style={showUnits() ? getObscuredText() : {}}>
                {getObscuredTextLabel(businessProfile?.businessName)}
              </h3>

              <h6 style={showUnits() ? getObscuredText() : {}}>
                {getObscuredTextLabel(businessProfile?.contactlegalname)}
                {/* {businessProfile?.contactlegalname} */}
              </h6>
              {/* {businessProfile?.email && loginUser && isApplicationApproved && (
                <p>
                  <i className="fa-solid fa-envelope"></i>{" "}
                  {businessProfile?.email}
                </p>
              )}
              {businessProfile?.phone && loginUser && isApplicationApproved && (
                <p>
                  <i className="fa-solid fa-phone"></i> {businessProfile?.phone}
                </p>
              )} */}

              {formatNull(businessProfile?.address) +
                formatNull(businessProfile?.street1) +
                formatNull(businessProfile?.street2) +
                formatNull(businessProfile?.city) +
                formatNull(businessProfile?.stateName) +
                formatNullWithOutComma(businessProfile?.countryName) &&
                loginUser && (
                  <p>
                    <i className="fa-solid fa-location-dot"></i>{" "}
                    {formatNull(businessProfile?.address) +
                      formatNull(businessProfile?.street1) +
                      formatNull(businessProfile?.street2) +
                      formatNull(businessProfile?.city) +
                      formatNull(businessProfile?.stateName) +
                      formatNullWithOutComma(businessProfile?.countryName)}
                  </p>
                )}
            </div>
            {!businessProfile?.isOrganizer && (
              <div className="star-review-list1">
                <div className="">
                  <div className="points-reviewa5">
                    {[
                      ...Array(parseInt(businessProfile?.averageRating ?? 0)),
                    ].map((star, index) => {
                      const currentRating = index + 1;

                      return (
                        <label className="rating-control" key={index}>
                          <input
                            type="radio"
                            name="rating"
                            value={currentRating}
                          />
                          <i className="fa-solid fa-star"></i>
                        </label>
                      );
                    })}{" "}
                    {businessProfile?.feedbackCount > 0 ? (
                      <h4>
                        <span>{`${parseFloat(
                          businessProfile?.averageRating ?? 0
                        ).toFixed(1)} (${
                          businessProfile?.feedbackCount
                        } Scoors On the Floors)`}</span>
                      </h4>
                    ) : (
                      ""
                    )}
                    {/* <h4><i className="fa-solid fa-star"></i> 5.00 <span> (1 Scoors On the Floors)</span></h4> */}
                  </div>
                  <div className="points-reviewa6">
                    {/* <a href="#">Write a review</a> */}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="star-review-list1">
            <div className="points-reviewa4">
              <div className="points-reviewa5"></div>
              <div className="points-reviewa6">
                {loginUser?.role !== businessProfile?.userType &&
                loginUser?.role !== UserRoleType.MOBILECATERERS &&
                loginUser?.role !== UserRoleType.CUSTOMER &&
                loginUser?.role !== UserRoleType.TRADERRETAILER &&
                loginUser?.role !== UserRoleType.UNKNOWN ? (
                  <button
                    onClick={() => {
                      if (loginUser) {
                        setShow(true);
                      } else {
                        dispatch({
                          type: CONSTANTS.SET_CURRENT_MODAL,
                          payload: CONSTANTS.LOGIN_MODAL,
                        });
                      }
                    }}
                  >
                    Write a review
                  </button>
                ) : (
                  <></>
                )}{" "}
                {shouldShowMessageButton && (
                  <button
                    onClick={async () => {
                      if (loginUser) {
                        navigate(routes.MESSAGE_INBOX, {
                          state: {
                            toUser: businessProfile,
                            isRedirect: true,
                            // isPreEventMessage: isApplicationApproved
                            //   ? false
                            //   : true,
                            // eventName: isApplicationApproved ? "" : eventName,
                          },
                        });
                      } else {
                        dispatch({
                          type: CONSTANTS.SET_CURRENT_MODAL,
                          payload: CONSTANTS.LOGIN_MODAL,
                        });
                      }
                    }}
                  >
                    Message
                  </button>
                )}
              </div>
            </div>
          </div>
          {reviews.length > 0 && (
            <div className="star-review-list">
              <div className="star-review-list1">
                {reviews.map((review, index) => (
                  <div key={index}>
                    <div className="review-star1">
                      <div className="review-star2">
                        <img
                          alt=""
                          src={
                            review?.fromUser?.businessLogo?.length > 0
                              ? review?.fromUser?.businessLogo
                              : "/assets/images/users/user-dummy-img.jpg"
                          }
                          onError={addUserDefaultImg}
                        />
                      </div>
                      <div className="review-star3">
                        {/* TODO uncomment :Point 43 */}
                        {/* {loginUser?.role !== UserRoleType.EO ? (
                          <h3>Anonymous</h3>
                        ) : (
                          <h3>{review.fromUser?.businessName}</h3>
                        )} */}
                        {review?.fromUser?.businessName && (
                          <h3>{review?.fromUser?.businessName}</h3>
                        )}
                        <h6>{formatDateENGB(review?.createdOn)} </h6>
                      </div>
                    </div>
                    <div className="five-star">
                      <div className="five-star1">
                        {[...Array(parseInt(review?.rating ?? 0))].map(
                          (star, index) => {
                            const currentRating = index + 1;

                            return (
                              <label className="rating-control" key={index}>
                                <input
                                  type="radio"
                                  name="rating"
                                  value={currentRating}
                                />
                                <i className="fa-solid fa-star"></i>
                              </label>
                            );
                          }
                        )}{" "}
                        {parseFloat(review?.rating).toFixed(1)}{" "}
                      </div>
                      <div className="five-star2">
                        <p>{review?.message} </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="pictures-review">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active"
                  id="simple-tab-0"
                  data-bs-toggle="tab"
                  href="#simple-tabpanel-0"
                  role="tab"
                  aria-controls="simple-tabpanel-0"
                  aria-selected="true"
                >
                  Pictures
                </a>
              </li>

              {/* {RolePermission.isAccess(
                loginUser?.role,
                AccountActionType.Units
              ) ? (
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="simple-tab-1"
                  data-bs-toggle="tab"
                  href="#simple-tabpanel-1"
                  role="tab"
                  aria-controls="simple-tabpanel-1"
                  aria-selected="false"
                >
                  Unit
                </a>
              </li>
 ) : (
  <></>
)} */}

              {showUnits() ? (
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    id="simple-tab-1"
                    data-bs-toggle="tab"
                    href="#simple-tabpanel-1"
                    role="tab"
                    aria-controls="simple-tabpanel-1"
                    aria-selected="false"
                  >
                    Unit
                  </a>
                </li>
              ) : (
                ""
              )}
            </ul>
            <div className="tab-content " id="tab-content">
              <div
                className="tab-pane active"
                id="simple-tabpanel-0"
                role="tabpanel"
                aria-labelledby="simple-tab-0"
              >
                <div className="row">
                  {imageList.map((image, index) => (
                    <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                      <img
                        style={{ width: "319px", height: "194px" }}
                        src={image?.imageUrls}
                        alt=""
                        onError={addDefaultImg}
                      />
                    </div>
                  ))}
                  {imageList?.length === 0 && (
                    <div
                      className="col-lg-3 col-md-6 col-sm-12"
                      style={{ minHeight: "100px" }}
                    >
                      {" "}
                      No pictures available
                    </div>
                  )}
                </div>
              </div>
              <div
                className="tab-pane"
                id="simple-tabpanel-1"
                role="tabpanel"
                aria-labelledby="simple-tab-1"
              >
                {units.map((unit, index) => (
                  <div key={index} className="row pt-2 pb-2 mb-3">
                    <h2 className="unit-name">{unit?.unitName}</h2>
                    <div className="col-md-3">
                      <img
                        src={unit?.imageUrl}
                        alt=""
                        onError={addDefaultImg}
                        style={getObscuredImages()}
                      />
                    </div>
                    <div className="col-md-7">
                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">Business Type : </div>
                        <div className="sec-col">{unit?.businessType} </div>
                      </div>
                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">
                          Date of Establishment :{" "}
                        </div>
                        <div className="sec-col">
                          {formatDateENGB(
                            unit?.establishmentDate.split("T")[0]
                          )}
                        </div>
                      </div>

                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">Address : </div>
                        <div className="sec-col">
                          {formatNull(unit?.street) +
                            formatNull(unit?.city) +
                            formatNull(unit?.stateName) +
                            formatNull(unit?.countryName) +
                            formatNullWithOutComma(unit?.zipCode)}
                        </div>
                      </div>

                      {loginUser && (
                        <div className="d-flex flex-sm-column flex-md-row flex-column">
                          <div className="first-col">Contact Number : </div>
                          <div className="sec-col" style={getObscuredText()}>
                            {getObscuredTextLabel(unit?.contactNumber)}
                          </div>
                        </div>
                      )}

                      {loginUser && (
                        <div className="d-flex flex-sm-column flex-md-row flex-column">
                          <div className="first-col">Email ID : </div>
                          <div className="sec-col" style={getObscuredText()}>
                            {getObscuredTextLabel(unit?.email)}
                          </div>
                        </div>
                      )}

                      <div className="d-flex flex-sm-column flex-md-row flex-column">
                        <div className="first-col">Contact Person : </div>
                        <div className="sec-col" style={getObscuredText()}>
                          {getObscuredTextLabel(unit?.contactPerson)}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 d-flex justify-content-md-end justify-content-sm-start">
                      <div className="d-flex flex-sm-row flex-md-column gp mt-2 mt-sm-2">
                        {getObscuredSection() && (
                          <div
                            style={{ cursor: "pointer" }}
                            className="icon-outer"
                            onClick={(e) => {
                              e.preventDefault();
                              getUnitDocuments(unit?.id);
                            }}
                          >
                            <img src="/assets/images/icon-doc.jpg" alt="" />
                            View Documents
                          </div>
                        )}

                        <div
                          style={{ cursor: "pointer" }}
                          className="icon-outer"
                          onClick={(e) => {
                            e.preventDefault();
                            getUnitShopFront(unit?.id);
                          }}
                        >
                          <img src="/assets/images/icon-shop.jpg" alt="" />
                          View Shopfront
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {units?.length === 0 && (
                  <div
                    className="col-lg-3 col-md-6 col-sm-12"
                    style={{ minHeight: "100px" }}
                  >
                    {" "}
                    No Shop front
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showModal} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Write a review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form aria-disabled="true" style={{ flex: 1 }}>
            {[...Array(totalStars)].map((star, index) => {
              const currentRating = index + 1;

              return (
                <label className="rating-control" key={index}>
                  <input
                    type="radio"
                    name="rating"
                    value={currentRating}
                    onChange={() => setRating(currentRating)}
                  />
                  <span
                    className="star"
                    style={{
                      color:
                        currentRating <= (hover || rating)
                          ? "#ffc107"
                          : "#e4e5e9",
                    }}
                    onMouseEnter={() => setHover(currentRating)}
                    onMouseLeave={() => setHover(null)}
                  >
                    &#9733;
                  </span>
                </label>
              );
            })}
            <fieldset>
              <Form.Group className="mb-3" controlId="formGridAddress1">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  onChange={(e) => {
                    setComment(e.target.value);
                  }}
                  rows={3}
                  defaultValue={comment}
                />
              </Form.Group>
            </fieldset>
          </Form>
          {error && <p className="text-danger">{error}</p>}
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleSubmit}>Submit</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showUnitDocumentModal}
        onHide={handleUnitDocumentClose}
        backdrop="static"
        centered
        dialogClassName="custom-modal modal-xl"
      >
        <Modal.Header closeButton className="modal-main-header"></Modal.Header>
        <Modal.Body>
          <div className="col-lg-12 col-sm-12">
            <div style={{ textAlign: "center" }}>
              {" "}
              <div className="logo-img">
                <img src="/assets/images/logo-swallow.jpg" alt="" />
              </div>
              <br />
              <h4 className="modal-title">Upload Document</h4>
              <br />
            </div>
          </div>
          <div className="col-lg-12 col-sm-12">
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Document Type</th>
                    <th>Title</th>
                    <th>Expiry Date</th>
                    {/* <th>Name</th>
            <th>Email</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {documentsList.map((document, idx) => (
                    <tr key={idx}>
                      <td>{document?.documentsTypeName}</td>
                      <td>
                        {document?.documentName ? document?.documentName : "-"}
                      </td>
                      <td>
                        {document?.expiryDate
                          ? formatDateENGB(document?.expiryDate.split("T")[0])
                          : "N/A"}
                      </td>
                      {/* <td>{businessData.contactlegalname}</td>
              <td>{businessData.email}</td> */}
                      {document?.documentFileURL && (
                        <td>
                          <span
                            onClick={() =>
                              handlePreview(document?.documentFileURL)
                            }
                            style={{
                              cursor: "pointer",
                              marginRight: "10px",
                              color: "#007bff",
                            }}
                          >
                            <i className="ri-eye-fill"></i> Preview
                          </span>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showUnitShopModal}
        onHide={handleUnitShopClose}
        backdrop="static"
        centered
        dialogClassName="custom-modal modal-xl"
      >
        <Modal.Header closeButton className="modal-main-header">
          {/* <Modal.Title className="modal-title-centered">
            <div className="login-img11">
              <img src="/assets/images/logo-swallow.jpg" alt="" />
            </div>
            <br />
            Unit Shopfronts
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12 col-sm-12">
            <div style={{ textAlign: "center" }}>
              {" "}
              <div className="logo-img">
                <img src="/assets/images/logo-swallow.jpg" alt="" />
              </div>
              <br />
              <h4 className="modal-title">Unit Shopfronts</h4>
              <br />
            </div>
          </div>
          <div className="col-lg-12 col-sm-12">
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Product Image</th>
                    <th>Product Title</th>
                    <th>Product Description</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {unitShopFronts.map((shop, idx) => (
                    <tr key={idx}>
                      <td>
                        <ImagePreview
                          src={shop?.imageUrl || routes.DEFAULT_IMAGE}
                          width="100px"
                          height="100px"
                          style={{
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            border: "2px solid darkgreen", // Corrected `BorderAll` typo
                          }}
                        ></ImagePreview>
                      </td>
                      <td>{shop?.productTitle ? shop.productTitle : "-"}</td>
                      <td>
                        {shop?.productDescription
                          ? shop?.productDescription
                          : "-"}
                      </td>
                      <td>
                        {shop?.price ? "£" + formatAmount(shop?.price) : "£0.00"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default injectModels(["application"])(TraderProfile);
